<template>
    <figcaption
        v-if="figcaptionText"
        :class="$style.visually_hidden"
    >
        {{ figcaptionText }}
    </figcaption>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { useTr } from '@/composables/use-tr'
import { useI18nAddon } from '@/i18n/i18n'
import type { APIGameType, GameCategoriesInfoType } from '@/types'

const props = defineProps<{
    game: APIGameType | undefined
    categories: GameCategoriesInfoType | undefined
}>()

const tr = useTr()
const { currentLocale } = useI18nAddon()

const figcaptionText = computed(() => {
    const category = props.categories?.categoriesInfo.find((c) => c.id === props.game?.main_category)

    if (!props.game || !category) {
        return ''
    }

    const options = {
        name: props.game.title,
        genre: (
            category.localizations?.find((l) => l.lang === currentLocale.value)?.title || category.title
        ).toLowerCase(),
    }

    return props.game.developer
        ? tr('seo.figcaption', { ...options, author: props.game.developer })
        : tr('seo.figcaption_no_author', options)
})
</script>
<style module>
.visually_hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
}
</style>
